module.exports = __webpack_public_path__ + "img/monitor.c8db09a5.svg";